import { Theme } from '@mui/material/styles';

export default function Checkbox({ palette }: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: palette.common.white,
          '&$checked': {
            color: palette.common.white
          }
        }
      }
    }
  };
}
